export default __webpack_public_path__ + "static/media/travily-1.7e572839.PNG";